import * as React from "react";
import { RouteComponentProps } from "@reach/router";

import { SidePadder } from "kanopi-components/SpaceWrapper/SidePadder";

import { FlowLayout } from "../../components/FlowLayout";
import { Payment } from "../components/Payment";

interface IPaymentPageProps extends RouteComponentProps {
  riskProfileId: number;
}

export function PaymentPage(props: IPaymentPageProps) {
  const { riskProfileId } = props;
  return (
    <SidePadder padding="flow">
      <FlowLayout
        steps={[
          { label: "Your details", complete: true },
          { label: "Your quote", complete: true },
          { label: "Review and buy", complete: true, active: true },
        ]}
        history={[{}, { key: "/quote/ready" }, {}]}
      >
        <Payment riskProfileId={riskProfileId} />
      </FlowLayout>
    </SidePadder>
  );
}
